import { useMutation } from 'react-query';
import request from '../../../helpers/request';

const mutationFn = ({ addressIds, stageId }) => {
  return request.put(
    'FlatsGrid/mass_change_stage_address_life_cycle',
    { addressIds, stageId },
    undefined,
    'Error',
    undefined,
    undefined,
    undefined,
    true
  );
};

export const useMassChangeStage = (options) => {
  return useMutation(mutationFn, options);
};
